import { JournalPage } from "components/frontComponents/journalPage/JournalPage";
import { RouterPathEnum } from "../../../shared/enums/commonEnums";
import styles from "./styles.module.scss";
import { MapWrap } from "./map/Map";
import { ScrollPageProps } from "../FirstPage";
import { Button } from "components/frontComponents/button/Button";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

export const Contacts: React.FC<ScrollPageProps> = ({
  scrollToRef,
  aboutRef,
  mainRef,
  featuresRef,
  contactsRef,
  activeSection,
}) => {
  const navigate = useNavigate();
  const [name, setName] = useState<string>("");
  const [mail, setMail] = useState<string>("");
  const [topic, setTopic] = useState<string>("");
  const [text, setText] = useState<string>("");
  return (
    <div className={styles.about} id="contacts">
      <JournalPage
        aboutRef={aboutRef}
        mainRef={mainRef}
        featuresRef={featuresRef}
        contactsRef={contactsRef}
        scrollToRef={scrollToRef}
        activeSection={activeSection}
        leftContent={
          <div className={styles.containerLeft}>
            <div className={styles.adresHolder}>
              <div className={styles.title}>Наш адрес</div>

              <div className={styles.adres}>
                <div className={styles.textline}>
                  <div className={styles.textStrong}>Адрес: </div>
                  <div className={styles.text}>
                    г. Томск, ул. Московский тракт, 2, строение 7
                  </div>
                </div>
              </div>
              <div className={styles.textline}>
                <div className={styles.textStrong}>Телефон: </div>
                <div className={styles.text}> 8 (3822) 901101 доб. 1982</div>
              </div>
              <div className={styles.textline}>
                <div className={styles.textStrong}>Email:</div>
                <div className={styles.text}>cyberfit@ssmu.ru</div>
              </div>
            </div>
            <div className={styles.mirrorContainer}>
              <div className={styles.mapOverlay}>
                <MapWrap />
              </div>
            </div>
          </div>
        }
        rightContent={
          <div className={styles.containerRight}>
            <div className={styles.application}>
              <div className={styles.titlePale}>Свяжитесь с командой</div>
              <div className={styles.textInput}>
                Готовы ответить, поддержать и найти лучшее решение
              </div>

              <form className={styles.formApplication}>
                <div className={styles.labeledInput}>
                  <label className={styles.label}>
                    <div className={styles.inputfake}>
                      <input
                        className={styles.inputBlock}
                        type="text"
                        name="name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder="Ваше имя"
                      />
                    </div>
                  </label>
                </div>
                <div className={styles.labeledInput}>
                  <label className={styles.label}>
                    <div className={styles.inputfake}>
                      <input
                        className={styles.inputBlock}
                        type="email"
                        name="email"
                        value={mail}
                        onChange={(e) => setMail(e.target.value)}
                        placeholder="Ваш email"
                      />
                    </div>
                  </label>
                </div>
                <div className={styles.labeledInput}>
                  <label className={styles.label}>
                    <div className={styles.inputfake}>
                      <input
                        className={styles.inputBlock}
                        type="text"
                        name="text"
                        value={topic}
                        onChange={(e) => setTopic(e.target.value)}
                        placeholder="Тема сообщения"
                      />
                    </div>
                  </label>
                </div>
                <div className={styles.labeledInput}>
                  <label className={styles.label}>
                    <div className={styles.inputfake}>
                      <input
                        className={styles.inputBlockBig}
                        type="text"
                        name="text"
                        value={text}
                        onChange={(e) => setText(e.target.value)}
                        placeholder="Ваше сообщение"
                      />
                    </div>
                  </label>
                </div>
                <Button
                  viewVariant="secondary"
                  text="Отправить"
                  className={styles.buttonapplication}
                  onClick={() => navigate(RouterPathEnum.Auth)}
                />
              </form>
            </div>
            <div className={styles.questions}>
              <div className={styles.questionTitleContainer}>
                <div className={styles.questionTitle}>
                  Часто задаваемые вопросы
                </div>
                <div className={styles.line} />
              </div>
              <div className={styles.questionsHolder}>
                <div className={styles.questionHolder}>
                  <div className={styles.question}>
                    Как связаться с поддержкой?
                  </div>
                  <div className={styles.answer}>
                    Вы можете написать нам на email или позвонить по указанному
                    номеру телефона
                  </div>
                </div>
                <div className={styles.questionHolder}>
                  <div className={styles.question}>
                    Как долго обрабатывается запрос?
                  </div>
                  <div className={styles.answer}>
                    Обычно мы отвечаем в течение 24 часов
                  </div>
                </div>
                <div className={styles.questionHolder}>
                  <div className={styles.question}>Где находится ваш офис?</div>
                  <div className={styles.answer}>
                    Наш офис находится по адресу: г. Томск, ул. Московский
                    тракт, 2, строение 7
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      />
    </div>
  );
};
